import { isMaybeIncognitoComet } from '#pplx/frontend/apps/ask/comet-shared/cometUtils.js';
import { handleCometActivationIncentive } from '#pplx/frontend/apps/ask/incentives/incentivesQueries.js';
import { trackDubLead } from '#pplx/frontend/apps/ask/queries/attribution-queries/trackDubLead.js';
import { FLOATING_SIGNUP_STATE_CHANGE_EVENT } from '#pplx/frontend/apps/ask/signup/floatingUpsellEvents.js';
import { resetSignupPopup } from '#pplx/frontend/apps/ask/signup/signupBannerDismissed.js';
import { getCookieCometQueryCountLoggedIn, incrementCometQueryCount, } from '#pplx/frontend/cookies/metadataCookieManager.js';
// Single-file events: defined here at their only call site rather than in a shared package.
const firstCometQueryFinishedEvent = {
    event: 'first comet query finished',
    data: {},
};
const thirdCometQueryFinishedEvent = {
    event: 'third comet query finished',
    data: {},
};
const RESURFACE_SIGNUP_POPUP_QUERY_COUNT = 2;
export const postFinalResponseClientSideLogic = ({ isUserLoggedIn, submissionQueryCount, session, track, sendQueryEventSingular, maybeSendNthQueryEventSingular, refetchHomepageUpsells, }) => {
    const isCometBrowser = isMaybeIncognitoComet();
    if (isCometBrowser) {
        incrementCometQueryCount(isUserLoggedIn);
    }
    if (!isUserLoggedIn && submissionQueryCount === RESURFACE_SIGNUP_POPUP_QUERY_COUNT) {
        resetSignupPopup();
        window.dispatchEvent(new CustomEvent(FLOATING_SIGNUP_STATE_CHANGE_EVENT));
    }
    refetchHomepageUpsells();
    // Note - only pass cometQueryCount if you are currently in Comet,
    // Otherwise you may trigger the same nth comet query event multiple times.
    sendQueryEventSingular();
    maybeSendNthQueryEventSingular({ isCometBrowser });
    const cometQueryCountLoggedIn = getCookieCometQueryCountLoggedIn();
    if (isCometBrowser && cometQueryCountLoggedIn === 1) {
        // if first logged in comet query, track affiliate lead via dub natively
        trackDubLead({
            eventName: 'activated',
            isDeferred: false,
            clickId: null,
            nextauthUserId: session?.user?.id ?? null,
            reason: 'comet attribution',
        });
        handleCometActivationIncentive({
            reason: 'comet activation incentive',
        });
        track(firstCometQueryFinishedEvent);
    }
    else if (isCometBrowser && cometQueryCountLoggedIn === 3) {
        track(thirdCometQueryFinishedEvent);
    }
};
//# sourceMappingURL=postFinalResponseClientSideLogic.js.map